import { SingleNews } from '@api';
import { Drawer } from '@design';
import { useDisableScroll } from '@helpers';
import { NewsBadges } from '@terminal/components/news-badges/NewsBadges';
import React from 'react';

import { ArticleDrawerContent } from './ArticleDrawerContent';
import { useSingleNews } from './hooks/use-single-news/useSingleNews';

export interface ArticleDrawerProps {
  list?: SingleNews[];
  newsId: string;
  onClick?: (singleNews: SingleNews) => void;
  onClose: () => void;
  disableFooter?: boolean;
}

export const ArticleDrawer = ({
  list = [],
  newsId,
  onClick,
  onClose,
  disableFooter = false,
}: ArticleDrawerProps) => {
  useDisableScroll();

  const initialNews = list.find(item => item.id === newsId);
  const { data, isError, isFetching } = useSingleNews(newsId, initialNews);

  return (
    <Drawer
      isOpen
      data-testid="article-drawer"
      handleCloseClick={onClose}
      headerButton={
        data && (
          <NewsBadges highlights={data.highlights} entityTags={data.entities} />
        )
      }
    >
      <ArticleDrawerContent
        isError={isError}
        isFetching={isFetching}
        data={data}
        list={list}
        onArticleClick={onClick}
        onClose={onClose}
        newsId={newsId}
        disableFooter={disableFooter}
      />
    </Drawer>
  );
};
